import React from 'react';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import StatTiles from './StatTiles';
import styles from './PatientSummaryCard.module.css';
import { formatBRL } from '../areas/financial/components/wallet-section/walletFormat';
import { formatDateBR, formatTimeBR, getLastCompleted, getNextUpcoming, timeSinceShort } from '../utils/appointmentSummary';

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

/**
 * Card de resumo no cabeçalho da ficha: responde de cara "quando volta, quando
 * veio, quantas vezes veio e deve alguma coisa?". Cada bloco é um atalho para a
 * seção que detalha o número.
 *
 * `appointments` e `financial` vêm do get_patient.php; `onOpenSection` recebe o
 * id da seção (Patient.js).
 */
function PatientSummaryCard({ appointments, financial, onOpenSection }) {
  const next = getNextUpcoming(appointments?.upcoming);
  const last = getLastCompleted(appointments?.history);
  const stats = appointments?.stats || {};
  const completed = Number(stats.completed) || 0;
  const noshow = Number(stats.noshow) || 0;
  const toReceive = Number(financial?.stats?.torecive) || 0;
  const openCount = (financial?.torecive || []).length;

  const tiles = [
    {
      key: 'next',
      icon: <EventAvailableOutlinedIcon />,
      label: 'Próximo agendamento',
      value: next ? formatDateBR(next) : 'Nenhum marcado',
      detail: next ? `às ${formatTimeBR(next)}` : 'Abra a agenda para marcar',
      accent: 'blue',
      onClick: () => onOpenSection('appointments'),
    },
    {
      key: 'last',
      icon: <HistoryOutlinedIcon />,
      label: 'Último atendimento',
      value: last ? formatDateBR(last) : 'Nunca veio',
      detail: last ? timeSinceShort(last) : 'Sem atendimento realizado',
      accent: 'teal',
      onClick: () => onOpenSection('appointments'),
    },
    {
      key: 'completed',
      icon: <CheckCircleOutlineIcon />,
      label: 'Atendimentos realizados',
      value: String(completed),
      detail: noshow > 0 ? plural(noshow, 'falta', 'faltas') : 'Nenhuma falta',
      accent: 'green',
      onClick: () => onOpenSection('appointments'),
    },
    {
      key: 'open',
      icon: <ReceiptLongOutlinedIcon />,
      label: 'Em aberto',
      value: formatBRL(toReceive),
      detail: openCount > 0 ? plural(openCount, 'atendimento sem pagamento', 'atendimentos sem pagamento') : 'Nada a receber',
      accent: toReceive > 0 ? 'amber' : 'green',
      onClick: () => onOpenSection('financial'),
    },
  ];

  return (
    <div className={styles.summary}>
      <span className={styles.eyebrow}>Resumo</span>
      <StatTiles items={tiles} className={styles.tiles} />
    </div>
  );
}

export default PatientSummaryCard;
